import React from 'react';
import Svg, {
  Defs, G, Path, Rect, Mask,
} from 'react-native-svg';
import isMobile from '../IsMobile';

const NoNotificationsImage = () => <Svg width='222' height='125' viewBox='0 0 222 125' fill='none'>
  <Rect x='34.5' width='154' height='120' rx='8' fill='#E6EEF7' />
  <Path d='M65.8755 37.7448C65.5151 35.2814 64.191 33.0621 62.1943 31.575C60.1976 30.088 57.6919 29.455 55.2286 29.8154C52.7652 30.1757 50.5459 31.4999 49.0588 33.4966C47.5718 35.4933 46.9388 37.9989 47.2992 40.4623C48.8844 51.2985 44.6932 55.0739 44.6932 55.0739L72.5577 50.9976C72.5577 50.9976 67.4607 48.5809 65.8755 37.7448Z' fill='#3379BD' />
  <Path d='M62.8788 55.0822C62.6252 56.0953 62.1766 56.971 61.5778 57.6217C60.979 58.2725 60.2512 58.6754 59.4671 58.7901C58.6831 58.9048 57.8703 58.7272 57.1103 58.2753C56.3502 57.8233 55.6695 57.1128 55.1363 56.2148' fill='#3379BD' />
  <Mask id='mask0_179_18242' maskUnits='userSpaceOnUse' x='44' y='29' width='29' height='27'>
    <Path d='M65.8764 37.7448C65.516 35.2814 64.1918 33.0621 62.1951 31.575C60.1984 30.088 57.6928 29.455 55.2294 29.8154C52.7661 30.1757 50.5467 31.4999 49.0597 33.4966C47.5726 35.4933 46.9397 37.9989 47.3 40.4623C48.8853 51.2985 44.6941 55.0739 44.6941 55.0739L72.5586 50.9976C72.5586 50.9976 67.4616 48.5809 65.8764 37.7448Z' fill='#548FC8' />
  </Mask>
  <G mask='url(#mask0_179_18242)'>
    <Rect width='42.2416' height='35.9836' rx='17.9918' transform='matrix(-0.999964 -0.00847547 -0.00847547 0.999964 59.2155 26.5352)' fill='#548FC8' />
  </G>
  <Path d='M109.952 74.8489L140.381 62.3779L196.75 83.3291L166.321 95.8L109.952 74.8489Z' fill='#8AB2D9' />
  <Path d='M109.952 74.8486L91.4954 81.8324L147.864 102.784L166.321 95.7998L109.952 74.8486Z' fill='#B0CBE6' />
  <Path d='M196.75 38.4336L140.381 17.4824V62.3778L196.75 83.329V38.4336Z' fill='#3379BD' />
  <Path d='M166.321 50.9055L196.75 38.4346V83.3299L166.321 95.8009V50.9055Z' fill='#548FC8' />
  <Path d='M166.321 50.9043L160.834 60.881V104.28L166.321 95.7997V50.9043Z' fill='#548FC8' />
  <Path d='M109.952 29.9534L140.381 17.4824V62.3778L109.952 74.8487V29.9534Z' fill='#548FC8' />
  <Path d='M109.952 29.953L89.5 26.96V72.853L109.952 74.8484V29.953Z' fill='#B0CBE6' />
  <Path d='M109.952 29.9534L140.381 17.4824L196.75 38.4336L166.321 50.9045L109.952 29.9534Z' fill='#B0CBE6' />
  <Path d='M109.952 29.9535L101.472 10L157.841 30.9512L166.321 50.9047L109.952 29.9535Z' fill='#8AB2D9' />
  <G filter='url(#filter0_d_179_18242)'>
    <Path d='M88.2398 97.0687L15.7909 120.039L40.2046 93.188L39.3945 89.8205L45.1675 80.9113L88.2398 97.0687Z' fill='white' />
    <Path d='M40.3101 93.0784L39.5 89.7109L88.3453 96.9592L40.3101 93.0784Z' fill='#E6EEF7' />
  </G>
  {!isMobile && <Defs>
    <filter id='filter0_d_179_18242' x='12.098' y='78.2733' width='79.9403' height='46.5138' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
      <feFlood floodOpacity='0' result='BackgroundImageFix' />
      <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
      <feMorphology radius='0.527559' operator='dilate' in='SourceAlpha' result='effect1_dropShadow_179_18242' />
      <feOffset dy='1.05512' />
      <feGaussianBlur stdDeviation='1.58268' />
      <feColorMatrix type='matrix' values='0 0 0 0 0.690196 0 0 0 0 0.796078 0 0 0 0 0.901961 0 0 0 0.08 0' />
      <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_179_18242' />
      <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_179_18242' result='shape' />
    </filter>
  </Defs>}
</Svg>;

export default NoNotificationsImage;
